import { AuthReducerModal } from "../../store/slices/initialState";
import services from '../../Constant/service';
import endpoint from '../../Constant/endpoint';
import { createSlice, createAsyncThunk, isPending, isFulfilled, isRejected } from '@reduxjs/toolkit';
const initialState = new AuthReducerModal();

const publicationSlice = createSlice({
  name: "publication",
  initialState,
  reducers: {
    set: (state, action) => ({ ...state, ...action.payload }),
    loader: (state, action) => ({ ...state, isLoader: action.payload }),
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(isPending, (state) => ({ ...state, isLoader: true }))
      .addMatcher(isFulfilled, (state, action) => {
        const actionName = action.type.split('/')[1];
        const dynamicKey = `${actionName}Response`;
        return {
          ...state,
          isLoader: false,
          [dynamicKey]: action.payload
        };
      })
      .addMatcher(isRejected, (state) => ({ ...state, isLoader: false }));
  },
});

export const addSellingSource = createAsyncThunk(
  'publication/addSellingSource',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.publication.addSellingSource,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);


export const getSellingSourceList = createAsyncThunk(
  'publication/getSellingSourceList',
  async ({ callback, errorCallback }: { callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.publication.getSellingSourceList, '',
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const updateSellingSource = createAsyncThunk(
  'publication/updateSellingSource',
  async ({ id, params, callback, errorCallback }: { id: any, params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.patchApiCall(
        endpoint.publication.updateSellingSource + id,
        params,
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.data?.statusCode === services?.status_code?.success) {

            callback(res.data);
            return res.data;
          } else {

            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteSellingSource = createAsyncThunk(
  'publication/deleteSellingSource',
  async ({ id, callback, errorCallback }: { id: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.deleteApiCall(
        endpoint.publication.deleteSellingSource + id, "",
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const addTds = createAsyncThunk(
  'publication/addSellingSource',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.publication.addTds,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getTdsList = createAsyncThunk(
  'publication/getSellingSourceList',
  async ({ callback, errorCallback }: { callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.publication.getTdsList, '',
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const updateTds = createAsyncThunk(
  'publication/updateTds',
  async ({ id, params, callback, errorCallback }: { id: any, params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.patchApiCall(
        endpoint.publication.updateTds + id,
        params,
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.data?.statusCode === services?.status_code?.success) {

            callback(res.data);
            return res.data;
          } else {

            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteTds = createAsyncThunk(
  'publication/deleteTds',
  async ({ id, callback, errorCallback }: { id: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.deleteApiCall(
        endpoint.publication.deleteTds + id, "",
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const vendorList = createAsyncThunk(
  'publication/vendorList',
  async ({ callback, errorCallback }: { callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.publication.vendorList, '',
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const addVendor = createAsyncThunk(
  'publication/addVendor',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.publication.addVendor,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getstate = createAsyncThunk(
  'publication/getSellingSourceList',
  async ({ callback, errorCallback }: { callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.publication.getstate, '',
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getCities = createAsyncThunk(
  "Publication/getCities",
  async (
    {
      id,
      callback,
      errorCallback,
    }: {
      id: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.publication.getCities + id,
        "",
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.status === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res?.data);
            return res?.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getTDSSectionList = createAsyncThunk(
  'publication/getTDSSectionList',
  async ({ callback, errorCallback }: { callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.publication.getTDSSectionList, '',
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);


export const deleteVendor = createAsyncThunk(
  'publication/deleteVendor',
  async ({ id, callback, errorCallback }: { id: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.deleteApiCall(
        endpoint.publication.deleteVendor + id, "",

        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.data?.statusCode === services?.status_code?.success) {

            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        },

      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const updateVendor = createAsyncThunk(
  'publication/updateVendor',
  async ({ id, params, callback, errorCallback }: { id: any, params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.patchApiCall(
        endpoint.publication.updateVendor + id,
        params,
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.data?.statusCode === services?.status_code?.success) {

            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const getOrdersList = createAsyncThunk(
  'publication/getOrdersList',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.publication.getOrdersList,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const addShipment = createAsyncThunk(
  'publication/addShipment',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.publication.addShipment,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const updateShipment = createAsyncThunk(
  'publication/updateShipment',
  async ({ id, params, callback, errorCallback }: { id: any, params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.patchApiCall(
        endpoint.publication.updateShipment + id,
        params,
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res?.data);
            return res?.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const scanProduct = createAsyncThunk(
  "Publication/scanProduct",
  async (
    {
      id,
      callback,
      errorCallback,
    }: {
      id: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.publication.scanProduct + id,
        "",
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.status === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res?.data);
            return res?.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const addStock = createAsyncThunk(
  'publication/addStock',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.publication.addStock,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const returnStock = createAsyncThunk(
  'publication/returnStock',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.publication.returnStock,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const transferStock = createAsyncThunk(
  'publication/transferStock',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.publication.transferStock,
        params,
        (res: any) => {

          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            callback(res);
            return res;
          }
          else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const sellStock = createAsyncThunk(
  'publication/sellStock',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.publication.sellStock,
        params,
        (res: any) => {

          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            callback(res);
            return res;
          }
          else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const uploadInvoice = createAsyncThunk(
  'publication/uploadInvoice',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      let formData = new FormData();
      formData.append("file", params);
      await services.postUploadMedia(
        endpoint.publication.uploadInvoice,
        formData,
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.statusCode === services?.status_code?.success) {

            callback(res);
            return res;
          } else {

            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const uploadStockImage = createAsyncThunk(
  'publication/uploadStockImage',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      let formData = new FormData();
      formData.append("file", params);
      await services.postUploadMedia(
        endpoint.publication.uploadStockImage,
        formData,
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.statusCode === services?.status_code?.success) {

            callback(res);
            return res;
          } else {

            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const productHistory = createAsyncThunk(
  'publication/productHistory',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.publication.productHistory,
        params,
        (res: any) => {

          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            callback(res);
            return res;
          }
          else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const productHistoryDetails = createAsyncThunk(
  'publication/productHistoryDetails',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.publication.productHistoryDetails,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            callback(res);
            return res;
          }
          else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);


export const getDamageStock = createAsyncThunk(
  'publication/getDamageStock',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.publication.getDamageStock,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            callback(res);
            return res;
          }
          else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);



export const { set, loader, reset } = publicationSlice.actions;
export default publicationSlice.reducer;